var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "26px",
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "super g") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V1.4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1--Sign-in-&-Security---Logins-A",
    transform: "translate(-382.000000, -726.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "super-g",
    transform: "translate(382.850000, 726.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.65,5.02666667 C16.2131667,5.02666667 17.9421667,6.08111111 18.928,6.96222222 L22.7803333,3.38 C20.4143333,1.28555556 17.3355,0 13.65,0 C8.31133333,0 3.70066667,2.91777778 1.456,7.16444444 L5.8695,10.4288889 C6.97666667,7.29444444 10.0403333,5.02666667 13.65,5.02666667 L13.65,5.02666667 Z",
    id: "Shape",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.754,13.2888889 C26.754,12.22 26.663,11.44 26.4658333,10.6311111 L13.65,10.6311111 L13.65,15.4555556 L21.1726667,15.4555556 C21.021,16.6544444 20.202,18.46 18.382,19.6733333 L22.6893333,22.8511111 C25.2676667,20.5833333 26.754,17.2466667 26.754,13.2888889 L26.754,13.2888889 Z",
    id: "Shape",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88466667,15.5711111 C5.5965,14.7622222 5.42966667,13.8955556 5.42966667,13 C5.42966667,12.1044444 5.5965,11.2377778 5.8695,10.4288889 L1.456,7.16444444 C0.530833333,8.92666667 0,10.9055556 0,13 C0,15.0944444 0.530833333,17.0733333 1.456,18.8355556 L5.88466667,15.5711111 L5.88466667,15.5711111 Z",
    id: "Shape",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65,26 C17.3355,26 20.4295,24.8444444 22.6893333,22.8511111 L18.382,19.6733333 C17.2293333,20.4388889 15.6823333,20.9733333 13.65,20.9733333 C10.0403333,20.9733333 6.97666667,18.7055556 5.88466667,15.5711111 L1.47116667,18.8355556 C3.71583333,23.0822222 8.31133333,26 13.65,26 L13.65,26 Z",
    id: "Shape",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 27.3 0 27.3 26 0 26"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.dba49d341c27c65144b3be90f855dd94.svg";
export { ForwardRef as ReactComponent };